import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Ссылка на диалог с пользователем во ВНУТРЕННЕМ telegram-client админки
// (/telegram-client), а не во внешнем Telegram. Чат авто-открывается по tgId.
export function telegramClientLink(user: { telegramId?: string | null; username?: string | null }): string | null {
  if (user.telegramId) return `/telegram-client?tgId=${encodeURIComponent(user.telegramId)}`
  if (user.username) return `/telegram-client?username=${encodeURIComponent(user.username)}`
  return null
}

// ISO/Date → локальная Date с тем же КАЛЕНДАРНЫМ днём, что и в UTC.
// Нужно, чтобы DatePicker (читает локальные компоненты) показывал хранимый UTC-день
// без сдвига в плюсовых зонах (напр. Asia/Tashkent UTC+5).
export function dateFromUtcDay(value: string | Date): Date {
  const d = new Date(value)
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
}

// Локальная дата → YYYY-MM-DD (без сдвига часового пояса).
export function toYmd(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, "0")
  const d = String(date.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}

// Конец выбранного дня в UTC (по локальной дате), чтобы доступ держался весь день.
export function endOfDayUtcIso(date: Date): string {
  return `${toYmd(date)}T23:59:59.999Z`
}

// Начало выбранного дня в UTC (полночь) — эквивалент new Date('YYYY-MM-DD').toISOString().
export function startOfDayUtcIso(date: Date): string {
  return `${toYmd(date)}T00:00:00.000Z`
}
